module.exports = __webpack_public_path__ + "static/image/history/pc/201803@3x.jpg?eb6713a4";